import { AssociationCategoryTypesToIds, HUBSPOT_DEFINED } from 'customer-data-objects/associations/AssociationCategoryTypes';
import { TASK_TO_COMPANY, TASK_TO_CONTACT, TASK_TO_DEAL, TASK_TO_TICKET } from 'customer-data-objects/associations/AssociationTypes';
import AssociationTypeToAssociationTypeId from 'customer-data-objects/associations/AssociationTypeToAssociationTypeId';
import { formatRawPhoneNumber } from './phoneNumbers';
import I18n from 'I18n';
import { OrderedMap } from 'immutable';
import getIn from 'transmute/getIn';
import memoize from 'transmute/memoize';
import makeCellForAssociationTextProperty from '../components/table/associations/makeCellForAssociationTextProperty';
import makeCellForAssociationType from '../components/table/associations/makeCellForAssociationType';
import { CompanyIndustryCell } from '../components/table/CompanyIndustryCell';
import { CompanyTargetAccountStatusCell } from '../components/table/CompanyTargetAccountStatusCell';
import LastEngagementCell from '../components/table/LastEngagementCell';
import LastTouchCell from '../components/table/LastTouchCell';
import TaskCompletionDateCell from '../components/table/TaskCompletionDateCell';
import TaskCreatedByCell from '../components/table/TaskCreatedByCell';
import TaskCreationDateCell from '../components/table/TaskCreationDateCell';
import TaskDueDateCell from '../components/table/TaskDueDateCell';
import TaskLastModifiedDateCell from '../components/table/TaskLastModifiedDateCell';
import TaskNotesCell from '../components/table/TaskNotesCell';
import TaskOwnerAssignedDateCell from '../components/table/TaskOwnerAssignedDateCell';
import TaskPriorityCell from '../components/table/TaskPriorityCell';
import TaskQueueCell from '../components/table/TaskQueueCell';
import TaskRepeatStatusCell from '../components/table/TaskRepeatStatusCell';
import TaskStatusCell from '../components/table/TaskStatusCell';
import TaskSubjectCell from '../components/table/TaskSubjectCell';
import { COMPANY_DOMAIN_PROPERTY_NAME, COMPANY_INDUSTRY_PROPERTY_NAME, COMPANY_TARGET_ACCOUNT_STATUS_PROPERTY_NAME, CONTACT_EMAIL_PROPERTY_NAME, CONTACT_JOB_TITLE_PROPERTY_NAME, CONTACT_PHONE_NUMBER_PROPERTY_NAME } from '../constants/properties';
import { ALL_PREDEFINED_COLUMNS, COLUMN_NAMES } from '../constants/table';
import get from './transmute';
import DomainCell from '../components/table/DomainCell';
import EmailCell from '../components/table/EmailCell';
import { jsx as _jsx } from "react/jsx-runtime";
export const CUSTOM_CELL_COMPONENTS = {
  [COLUMN_NAMES.COMPANY_INDUSTRY]: makeCellForAssociationTextProperty({
    CellComponent: CompanyIndustryCell,
    associationCategoryId: AssociationCategoryTypesToIds[HUBSPOT_DEFINED],
    associationTypeId: get(TASK_TO_COMPANY, AssociationTypeToAssociationTypeId),
    property: COMPANY_INDUSTRY_PROPERTY_NAME
  })
};
export const CUSTOM_COLUMN_COMPONENTS = {
  [COLUMN_NAMES.TASK_TO_CONTACT]: makeCellForAssociationType(AssociationCategoryTypesToIds[HUBSPOT_DEFINED], get(TASK_TO_CONTACT, AssociationTypeToAssociationTypeId)),
  [COLUMN_NAMES.TASK_TO_COMPANY]: makeCellForAssociationType(AssociationCategoryTypesToIds[HUBSPOT_DEFINED], get(TASK_TO_COMPANY, AssociationTypeToAssociationTypeId)),
  [COLUMN_NAMES.TASK_TO_DEAL]: makeCellForAssociationType(AssociationCategoryTypesToIds[HUBSPOT_DEFINED], get(TASK_TO_DEAL, AssociationTypeToAssociationTypeId)),
  [COLUMN_NAMES.TASK_TO_TICKET]: makeCellForAssociationType(AssociationCategoryTypesToIds[HUBSPOT_DEFINED], get(TASK_TO_TICKET, AssociationTypeToAssociationTypeId)),
  [COLUMN_NAMES.CONTACT_EMAIL]: makeCellForAssociationTextProperty({
    CellComponent: EmailCell,
    associationCategoryId: AssociationCategoryTypesToIds[HUBSPOT_DEFINED],
    associationTypeId: get(TASK_TO_CONTACT, AssociationTypeToAssociationTypeId),
    property: CONTACT_EMAIL_PROPERTY_NAME
  }),
  [COLUMN_NAMES.COMPANY_DOMAIN]: makeCellForAssociationTextProperty({
    CellComponent: DomainCell,
    associationCategoryId: AssociationCategoryTypesToIds[HUBSPOT_DEFINED],
    associationTypeId: get(TASK_TO_COMPANY, AssociationTypeToAssociationTypeId),
    property: COMPANY_DOMAIN_PROPERTY_NAME
  }),
  [COLUMN_NAMES.COMPANY_TARGET_ACCOUNT_STATUS]: makeCellForAssociationTextProperty({
    CellComponent: CompanyTargetAccountStatusCell,
    associationCategoryId: AssociationCategoryTypesToIds[HUBSPOT_DEFINED],
    associationTypeId: get(TASK_TO_COMPANY, AssociationTypeToAssociationTypeId),
    property: COMPANY_TARGET_ACCOUNT_STATUS_PROPERTY_NAME
  }),
  [COLUMN_NAMES.CONTACT_PHONE_NUMBER]: makeCellForAssociationTextProperty({
    associationCategoryId: AssociationCategoryTypesToIds[HUBSPOT_DEFINED],
    associationTypeId: get(TASK_TO_CONTACT, AssociationTypeToAssociationTypeId),
    CellComponent: ({
      value
    }) => /*#__PURE__*/_jsx("span", {
      children: formatRawPhoneNumber(value)
    }),
    property: CONTACT_PHONE_NUMBER_PROPERTY_NAME
  }),
  [COLUMN_NAMES.CONTACT_JOB_TITLE]: makeCellForAssociationTextProperty({
    associationCategoryId: AssociationCategoryTypesToIds[HUBSPOT_DEFINED],
    associationTypeId: get(TASK_TO_CONTACT, AssociationTypeToAssociationTypeId),
    property: CONTACT_JOB_TITLE_PROPERTY_NAME
  }),
  [COLUMN_NAMES.TITLE]: TaskSubjectCell,
  [COLUMN_NAMES.LAST_TOUCH]: LastTouchCell,
  [COLUMN_NAMES.LAST_ENGAGEMENT]: LastEngagementCell,
  [COLUMN_NAMES.DUE_DATE]: TaskDueDateCell,
  [COLUMN_NAMES.PRIORITY]: TaskPriorityCell,
  [COLUMN_NAMES.STATUS]: TaskStatusCell,
  [COLUMN_NAMES.COMPLETED_AT]: TaskCompletionDateCell,
  [COLUMN_NAMES.LAST_MODIFIED_DATE]: TaskLastModifiedDateCell,
  [COLUMN_NAMES.NOTES]: TaskNotesCell,
  [COLUMN_NAMES.CREATED_AT]: TaskCreationDateCell,
  [COLUMN_NAMES.OWNER_ASSIGNED_DATE]: TaskOwnerAssignedDateCell,
  [COLUMN_NAMES.QUEUE_IDS]: TaskQueueCell,
  [COLUMN_NAMES.REPEAT_STATUS]: TaskRepeatStatusCell,
  [COLUMN_NAMES.CREATED_BY]: TaskCreatedByCell
};

// Only for columns that do not directly correspond to a task property,
// or for task property columns where the default property label should be overridden
export const CUSTOM_COLUMN_HEADER_I18N_KEYS = {
  [COLUMN_NAMES.TASK_TO_CONTACT]: 'tasks-table.headers.contact',
  [COLUMN_NAMES.TASK_TO_COMPANY]: 'tasks-table.headers.company',
  [COLUMN_NAMES.TASK_TO_DEAL]: 'tasks-table.headers.deal',
  [COLUMN_NAMES.TASK_TO_TICKET]: 'tasks-table.headers.ticket',
  [COLUMN_NAMES.CONTACT_EMAIL]: 'tasks-table.headers.contactEmail',
  [COLUMN_NAMES.COMPANY_DOMAIN]: 'tasks-table.headers.companyDomain',
  [COLUMN_NAMES.COMPANY_INDUSTRY]: 'tasks-table.headers.companyIndustry',
  [COLUMN_NAMES.COMPANY_TARGET_ACCOUNT_STATUS]: 'tasks-table.headers.companyTargetAccountStatus',
  [COLUMN_NAMES.CONTACT_PHONE_NUMBER]: 'tasks-table.headers.contactPhoneNumber',
  [COLUMN_NAMES.CONTACT_JOB_TITLE]: 'tasks-table.headers.contactJobTitle',
  // Task property columns, included so default label is overridden
  [COLUMN_NAMES.LAST_TOUCH]: 'tasks-table.headers.lastTouch',
  [COLUMN_NAMES.LAST_ENGAGEMENT]: 'tasks-table.headers.lastEngagement',
  [COLUMN_NAMES.NOTES]: 'tasks-table.headers.notes',
  [COLUMN_NAMES.STATUS]: 'tasks-table.headers.status',
  [COLUMN_NAMES.TITLE]: 'tasks-table.headers.title',
  [COLUMN_NAMES.PRIORITY]: 'tasks-table.headers.priority',
  [COLUMN_NAMES.REPEAT_STATUS]: 'tasks-table.headers.repeatStatus'
};

/**
 * Get label for a column
 * @param {Object} input with values
 * - columnName (String): column name as specified in COLUMN_NAMES in constants/table.js
 * - customAssociationColumnNamesToDefinitions (Map): map of custom column names (custom object association or user-defined association label)
 *     to additional data on the custom object or association label
 * - properties (Map):  map of property names to property definitions
 */
export const getColumnLabel = memoize(({
  columnName,
  customAssociationColumnNamesToDefinitions = OrderedMap(),
  properties = OrderedMap()
}) => {
  // Non-custom object columns
  if (ALL_PREDEFINED_COLUMNS.includes(columnName)) {
    // Columns that don't correspond to a task property or that have their default property label overriden
    if (columnName in CUSTOM_COLUMN_HEADER_I18N_KEYS) {
      return I18n.text(CUSTOM_COLUMN_HEADER_I18N_KEYS[columnName]);
    }
    // Task property columns that should use default property label
    else {
      return getIn([columnName, 'label'], properties);
    }
  } else {
    // Association label is expected to only be defined for user-defined associations/association labels (flexible associations)
    const customAssociationLabel = getIn([columnName, 'associationLabel'], customAssociationColumnNamesToDefinitions);
    if (customAssociationLabel) {
      return I18n.text('tasks-table.headers.customAssociationLabel', {
        associationLabel: customAssociationLabel
      });
    }
    const customObjectSingularForm = getIn([columnName, 'singularForm'], customAssociationColumnNamesToDefinitions);
    if (customObjectSingularForm) {
      return I18n.text('tasks-table.headers.customObjectAssociation', {
        customObjectSingularForm
      });
    }
    return I18n.text('tasks-table.headers.customObjectAssociationPlaceholder');
  }
});
export const getColumnHeaderComponent = ({
  columnName,
  customAssociationColumnNamesToDefinitions = OrderedMap(),
  properties = OrderedMap()
}) => {
  const seleniumSelector = `${columnName}-column`;
  const columnLabel = getColumnLabel({
    columnName,
    customAssociationColumnNamesToDefinitions,
    properties
  });
  return /*#__PURE__*/_jsx("span", {
    "data-selenium-test": seleniumSelector,
    children: columnLabel
  });
};